<template>
  <v-card class="main-content-card" flat>
    <v-toolbar flat>
      <v-toolbar-title>论文登记</v-toolbar-title>
      <span class="subheading ml-2">|</span>
      <v-btn round small color="orange darken-1" class="white--text"
             :disabled="!funcIds.includes('u_papr_submit')"
             @click.native.stop="() => { editDbid = null; editJ = true; }">
        <v-icon dark small>book</v-icon>登记期刊论文
      </v-btn>
      <v-btn round small color="teal" dark
             :disabled="!funcIds.includes('u_papr_submit')"
             @click.native.stop="() => { editDbid = null; editC = true; }">
        <v-icon dark small>group</v-icon>登记会议论文
      </v-btn>
      <v-spacer/>

    </v-toolbar>

    <v-divider/>
    <!-- 检索功能区 -->
    <v-container fluid grid-list-md class="px-4" style="background-color: rgba(245, 245, 245, 0.6);">
      <v-layout row wrap>
        <v-flex d-flex xs10>
          <v-layout row wrap>
            <v-flex xs12 sm8>
              <v-text-field
                label="论文标题"
                v-model="form.title"
                :clearable="true"
                hide-details
              />
            </v-flex>

            <v-flex xs12 sm4>
              <v-text-field
                label="刊物名称"
                v-model="form.publication"
                :clearable="true"
                hide-details
              />
            </v-flex>

            <v-flex xs12 sm3>
              <v-menu
                ref="menuPublDateStart"
                :close-on-content-click="false"
                v-model="menuPublDateStart"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="form.publDateStart"
                  label="发表时间(起始)"
                  :rules="rules.startDate"
                  hint="格式YYYY-MM, 如：2018-10"
                  persistent-hint
                />
                <v-date-picker
                  v-model="publDateStart"
                  type="month"
                  locale="zh-cn"
                  @change="nv => form.publDateStart = nv"
                />
              </v-menu>
            </v-flex>

            <v-flex xs12 sm3>
              <v-menu
                ref="menuPublDateEnd"
                :close-on-content-click="false"
                v-model="menuPublDateEnd"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="form.publDateEnd"
                  label="发表时间(截止)"
                  :rules="rules.endDate"
                  hint="格式YYYY-MM, 如：2018-10"
                  persistent-hint
                />
                <v-date-picker
                  v-model="form.publDateEnd"
                  type="month"
                  locale="zh-cn"
                  @change="nv => form.publDateEnd = nv"
                />
              </v-menu>
            </v-flex>

            <v-flex xs12 sm2>
              <v-select
                label="检索情况"
                item-value="dbid"
                item-text="name"
                :items="indexItems"
                v-model="form.indexId"
                clearable
              />
            </v-flex>

            <v-flex xs12 sm4>
              <v-autocomplete
                item-text="name"
                item-value="dbid"
                :items="deptItems"
                v-model="form.deptId"
                label="归属部门"
                hide-details
                clearable
              />
            </v-flex>


            <v-flex xs12>
              <span>审核状态：</span>
              <v-btn-toggle
                v-model="form.statusId"
                class="transparent"
                style="background:none;box-shadow:none"
              >
                <v-btn value="" flat>全部</v-btn>
                <v-btn flat v-for="s in statusItems" :key="s.dbid" :value="s.identifier">{{s.name}}</v-btn>
              </v-btn-toggle>
            </v-flex>

          </v-layout>
        </v-flex>
        <v-flex d-flex xs2 text-xs-center>
          <div>
            <v-btn color="primary" @click="onSearch">
              <v-icon dark>search</v-icon>
              检索
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
    </v-container>

    <v-divider/>

    <v-data-table
      :headers="headers"
      :loading="loading"
      item-key="dbid"
      :pagination.sync="query"
      :items="pageResult.items"
      :total-items="pageResult.total"
      rows-per-page-text="每页记录数"
      no-data-text="没有数据。"
      no-results-text="没有符合条件的记录。"
    >
      <template slot="items" slot-scope="props">
        <td>
          {{ props.index + 1}}
        </td>
        <td>
          <span style="font-weight: bold">{{ props.item.title }}</span>
          <br/>
          <span
            style="color: red"
            v-if="props.item.category  === 'J' && !props.item.journalId"
          >[目录外]</span>
          {{ props.item.publication }}
        </td>

        <td>
          <span style="font-weight: bold">
            {{ props.item.authors.map(a => `${a.name}(${a.rank})`).join(',') }}
          </span>
          <br/>
          {{ props.item.department.name }}
        </td>

        <td>
          <span style="font-weight: bold">
            {{ props.item.indexings? props.item.indexings.map(a => `${a.name}`).join(',') : ''}}
          </span>
          <br/>
          {{ props.item.level? props.item.level.name : '' }}
        </td>

        <td>
          {{ categories[props.item.category] || props.item.category }}
        </td>

        <td>
          {{ props.item.publDate.substring(0,7) }}
        </td>

        <td>
          <v-tooltip top>
            <v-chip small label class="mx-0" slot="activator"
                    :color="props.item.status.color"
                    @click="() => { history=props.item.history; hist = true; }">
              {{ props.item.status.name }}
            </v-chip>
            <span>点击查看审核历史</span>
          </v-tooltip>
        </td>

        <td class="justify-center layout px-0">
          <v-tooltip top>
            <v-btn icon class="mx-0" slot="activator"
                   @click="() => { viewDbid = props.item.dbid; view = true; }">
              <v-icon color="teal">more_horiz</v-icon>
            </v-btn>
            <span>查看</span>
          </v-tooltip>
          <v-tooltip top>
            <v-btn icon class="mx-0" slot="activator"
                   @click="() => { editDbid = props.item.dbid; props.item.category ==='J' ? editJ = true : editC = true; }"
                   :disabled="submitDisabled(props.item)">
              <v-icon color="teal">edit</v-icon>
            </v-btn>
            <span>编辑</span>
          </v-tooltip>
          <v-tooltip top>
            <v-btn icon class="mx-0" slot="activator"
                   @click="() => { rowIdx = props.index; submitDbid = props.item.dbid; submitMsg = props.item.title; submit = true; }"
                   :disabled="submitDisabled(props.item)">
              <v-icon color="teal">publish</v-icon>
            </v-btn>
            <span>提交</span>
          </v-tooltip>
          <v-tooltip top>
            <v-btn icon class="mx-0" slot="activator"
                   @click="() => { deleDbid = props.item.dbid; deleMsg = props.item.title; dele = true; }"
                   :disabled="submitDisabled(props.item)">
              <v-icon color="pink">delete_forever</v-icon>
            </v-btn>
            <span>删除</span>
          </v-tooltip>
        </td>
      </template>
    </v-data-table>

    <x-view
      v-model="view"
      :dbid="viewDbid"
    />

    <x-submit
      v-model="submit"
      :dbid="submitDbid"
      :message="submitMsg"
      :uri="uri"
      @ok="(it) => Object.assign(pageResult.items[rowIdx],it)"
    />

    <x-review
      v-model="review"
      :dbid="reviewDbid"
      :message="reviewMsg"
      :uri="uri"
      :actions="reviewActs"
      @ok="(it) => Object.assign(pageResult.items[rowIdx],it)"
    />

    <x-edit-j
      v-model="editJ"
      :dbid="editDbid"
      v-on:ok="onEditOk"
    />

    <x-edit-c
      v-model="editC"
      :dbid="editDbid"
      v-on:ok="onEditOk"
    />

    <x-delete
      v-model="dele"
      :message="deleMsg"
      :uri="uri"
      :dbid="deleDbid"
      v-on:ok="onDeleOk"
    />

    <x-history
      v-model="hist"
      :history="history"
      :status="statusItems"
    />

  </v-card>
</template>

<script>
  import {mapGetters} from 'vuex'

  import XView from './View'
  import XEditJ from './EditJournalPaper'
  import XEditC from './EditConferencePaper'

  import XDelete from '@/components/global/Delete'
  import XReview from '@/components/global/Review'
  import XSubmit from '@/components/global/Submit'
  import XHistory from '@/components/global/History'

  import mixin from '@/mixin'

  const baseUri = '/api/papr/paper';
  const statusUri = '/api/code/status';
  const deptUri = '/api/syst/department';
  const indexingURI = '/api/papr/indexing/';


  export default {
    // 混入模块主页面（index）基本功能
    mixins: [mixin.index(baseUri + '/by/request/user')],

    components: {XView, XEditJ, XEditC, XDelete, XReview, XSubmit, XHistory},

    data() {
      return {
        uri: baseUri,
        // 检索、分页、排序条件条件
        query: {
          statusId: '',
          title: '',
          author: '',
          publDateStart: '',
          publDateEnd: '',
          publication: '',
          indexId:'',

          page: 1,
          rowsPerPage: 25,
          sortBy: null,
          descending: null,
          totalItems: null
        },

        // 检索框
        form: {
          statusId: '',
          title: '',
          author: '',
          publDateStart: '',
          publDateEnd: '',
          publication: '',
          indexId:''
        },

        statusItems:[],
        categories: {
          "J": "期刊",
          "C": "会议"
        },
        deptItems: [],

        menuPublDateStart: false,
        publDateStart: null,

        menuPublDateEnd: false,
        publDateEnd:null,

        indexItems: [],

        // 表头
        headers: [
          {text: '#', align: 'left', sortable: false, value: 'dbid', width: "20"},
          {text: '标题 / 刊物名称', align: 'left', sortable: true, value: 'title'},
          {text: '作者 / 归属部门', align: 'left', sortable: true, value: 'authors'},
          {text: '检索情况 / 级别', align: 'left', sortable: true, value: 'level'},
          {text: '类别', align: 'left', sortable: true, value: 'category'},
          {text: '发表时间', align: 'left', sortable: true, value: 'publDate'},
          {text: '审核状态', align: 'left', sortable: true, value: 'statusId'},
          {text: '操作', align: 'center', sortable: false, value: 'dbid', width: "180"}
        ],

        rowIdx: null,

        view: false,
        viewDbid: null,

        submit: false,
        submitDbid: null,
        submitMsg: null,

        review: false,
        reviewDbid: null,
        reviewMsg: null,
        reviewActs: [],

        editJ: false,
        editC: false,
        editDbid: null,

        dele: false,
        deleDbid: null,
        deleMsg: null,

        hist: false,
        history: [],

        rules: {
          startDate: [
            v => !!v || "必填项。",
            v => window.xutil.regexpMonth().test(v) || '日期格式错误'
          ],
          endDate: [
            v => !!v || "必填项。",
            v => (v && window.xutil.regexpMonth().test(v)) || '日期格式错误',
            v => (v && v > this.form.publDateStart) || "截止日期必须晚于起始日期。"
          ]
        }
      }
    },

    created() {
      // 加载审核状态
      this.axios.all([
        this.axios.get(statusUri, {params: {sort: 'rank.asc'}}),
        this.axios.get(deptUri, {params: {limit: 65535, disabled: 'F', sort: 'rank.asc'}}),
        this.axios.get(indexingURI, {params: {limit: 65535, disabled: 'F', sort: 'order.asc'}}),
      ]).then(
        this.axios.spread(
          (rspStaus, rspDept, rspIdx) => {
            this.statusItems = rspStaus.data.items;
            this.deptItems = rspDept.data.items;
            this.indexItems = rspIdx.data.items;
          }
        )
      )
    },

    computed: {
      ...mapGetters(['funcIds'])
    },

    methods: {
      // 检索响应函数
      onSearch() {
        Object.assign(this.query, this.form);
        this.query.page = 1;
        this.doRoute(this.query);
      },
      submitDisabled(item) {
        return !(
          // 当前用户拥有提交功能
          this.funcIds.includes('u_papr_submit')
          // 并且，当前记录需要提交
          && item.actions.find(a => a.action === 'submit'))
      }
    }
  }
</script>
